import {useRouteTemplates} from "hooks/useRouteTemplates";
import {useSetting} from "../../contexts/setting";
import cn from "classnames";
import TemplateControls from "../../layout/TemplateControls";
import SortableList from "../../layout/SortableList";
import "./index.css";

const Social = () => {
  const {visible, currentVideoPopup, bases} = useSetting();

  // Without the banners an admin removed (libs/bannerComposition.ts).
  const filteredTemplates = useRouteTemplates("email");
  const bannerIds = filteredTemplates.map((template) => template.id);
  const hasOnlyOneBanner = bannerIds.length === 1;

  return (
    <SortableList
      items={filteredTemplates}
      useDragHandle={true}
      getItemClassName={(item) =>
        cn("template-wrap", {
          hidden: !hasOnlyOneBanner && !visible.some((x) => x === item.id),
          popup: currentVideoPopup === item.id,
        })
      }
      // `--base-color` is a scene scalar on `.templates-inner` (App.js); a
      // banner that set its base apart on its look redeclares it here, so the
      // fill under its artwork is its own and every other banner keeps the
      // shared one. Same element the renderer screenshots, so an export and
      // the editor cannot disagree.
      getItemStyle={(item) => (bases?.[item.id] ? {"--base-color": `#${bases[item.id]}`} : undefined)}
      renderItem={(item, {listeners, attributes} = {}) => (
        <>
          <div
            className="template-annotation"
            {...(listeners || {})}
            {...(attributes || {})}
            style={{cursor: "grab"}}
          >
            <span className="label">{`${item.label} (${item.dimensions}${item.suffix || ""})`}</span>
            <TemplateControls
              id={item.id}
              templateChannel="email"
              hasOnlyOneBanner={hasOnlyOneBanner}
              bannerIds={bannerIds}
            />
          </div>
          {item.getComponent()}
        </>
      )}
    />
  );
};

export default Social;
